<template>
    <div class="view view-challenge">
        <HeaderChallenge
            textH1="Meydan Okuma"
            textH2="İsteklerine veya geçmişine bak" />
        <ChallengeLinkInitialize />
        <ChallengeLinkRequests />
        <ChallengeRecentChallenges />

        <BtnChallenge @click="routeSelectUser"/>
        <BtnPracticeModes @click="routePracticeModes"/>
        <Navbar />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallenge          from '@/components/HeaderChallenge';
    import ChallengeLinkInitialize  from '@/components/ChallengeLinkInitialize.vue';
    import ChallengeLinkRequests    from '@/components/ChallengeLinkRequests.vue';
    import ChallengeRecentChallenges from '@/components/ChallengeRecentChallenges.vue';
    import BtnChallenge             from '@/components/BtnChallenge.vue';
    import BtnPracticeModes         from '@/components/BtnPracticeModes.vue';
    import Navbar                   from '@/components/Navbar.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallenge,
            ChallengeLinkInitialize,
            ChallengeLinkRequests,
            ChallengeRecentChallenges,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        methods: {
            routeSelectUser(){
                this.$router.push('/challenge/select-user');
            },

            routePracticeModes(){
                this.$router.push('/practice-modes');
            },

            incrementZIndex(){
                if(window.scrollY > 13){
                    document.querySelector('.header-challenge').style.zIndex = 5;
                }
                else{
                    document.querySelector('.header-challenge').style.zIndex = "";
                }
            }
        },

        mounted(){
            window.addEventListener('scroll', this.incrementZIndex);
        },

        unmounted(){
            window.removeEventListener('scroll', this.incrementZIndex);
        },

    };
</script>

<style scoped src="@/css/views/view-challenge.css"></style>